<template>
  <v-container class="justify-center">
   <v-card 
   max-width="600px"
    persistent
    min-width="360px">
    <v-card-title class="m4u_text--text primary text-center">Set a New Password</v-card-title>
     <v-card-text>
        <v-card-subtitle>{{message}}</v-card-subtitle>
        <v-text-field
            v-model="email"
            tabindex="1"
            :rules="emailRules"
            label="E-mail"
            required
            color="m4u_text"
        ></v-text-field>

        <v-text-field
          v-model="password"
          tabindex="2"
          :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
          :rules="[rules.required]"
          :type="show1 ? 'text' : 'password'"
          name="input-10-1"
          label="Password"
          @click:append="show1 = !show1"
              :toggle="true"

        ></v-text-field>
        <span class="red--text" v-if="passwordStrength.score < 4 && password.length >0">Weak Password<br /> 
        <span v-if="passwordStrength.feedback.suggestions.length > 0">{{passwordStrength.feedback.suggestions}} </span>
        <span v-if="passwordStrength.feedback.suggestions.length === 0">Almost strong enough! </span>
        </span> 
        <span class="green--text" v-if="passwordStrength.score >= 4">Strong Password</span>

        <v-text-field
            v-model="password2"
            tabindex="3"
            :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
            :rules="[rules.required, rules.passwordMatch]"
            :type="show2 ? 'text' : 'password'"
            name="input-10-2"
            label="Confirm Password"
            @click:append="show1 = !show1"
        ></v-text-field>

        <v-btn small class="primary m4u_text--text" @click="resetCheck()" v-if="buttonShow==='Reset'" tabindex="4">Change Password</v-btn>
        <v-btn small class="primary m4u_text--text" @click="goToLogin()" v-if="buttonShow==='Login'" tabindex="4">Login</v-btn>

    </v-card-text> 
</v-card> 
  </v-container>
</template>

<script>
 import EventService from "@/services/EventService.js";
 import Password from 'zxcvbn';
export default {
  components: { Password },
    computed: {
    passwordMatch() {
      return () => this.password === this.password2 || "Password must match";
    },
    passwordStrength(){
        return Password( this.password );
    }
  },


  data() {
    return {
        verifyCode: this.$route.query.verifyCode,
        email: '',
        password: '',
        password2: '',
        verify: "",
        show1: false, 
        show2: false,
        emailRules: [
          (v) => !!v || "Required",
          (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
        ],
        message: '',
        buttonShow: 'Reset',
            rules: {
      required: (value) => !!value || "Required.",
      min: (v) => (v && v.length >= 8) || "Min 8 characters",
    },
    };
  },
  mounted() {

  },
  methods: {
    validateReg() {
      if (this.$refs.registerForm.validate()) {

        if(this.passwordStrength.score < 4) {
          this.errMsg = "Password must be stronger"
          return
        }
        this.errMsg = "";
        this.resetCheck();
      }
    },
      async resetCheck() {
      try {
      await EventService.resetCheck(this.email, this.verifyCode)
      .then(async (resetCheck) => {
          if(resetCheck !== 'Valid') {
              this.message = 'Your change request has expired. Please go to Forgot Password again.';
          } else {
              this.message = ''
            await EventService.resetPassword(this.email, this.password)
            .then((resetPWreturn) => {
                if (resetPWreturn === 'successful') {
                    this.message = 'Password change successful.'
                    this.buttonShow = 'Login'
//                    console.log('buttonShow is: ', this.buttonShow)
                } else {
                    this.message = 'Something went wrong. Please try again.'
                    this.buttonShow = 'Reset'
                }
            } )
          }

      }) 
      }
      catch(error) {
          console.log(error)
      }      
      },  //end of saveNewPassword

      goToLogin() {
          this.$router.push('Login');
      }
    }
};
</script>
<style lang="scss" scoped>
body {
  background: green;
}
.org-description {
  margin-top: 50px;
}
</style>
